function Dummy(props){
    return (
        <div style={
            {
                width:(props.width?props.width:null), 
                height:(props.height?props.height:null)
            }
        }></div>
    )
}

export default Dummy;